import {assertAndContinue} from 'Asserts';
import BenchlingConfig from 'BenchlingConfig';
import getParameterNamesInSQLQueries from 'insights/parameters/data/getParameterNamesInSQLQueries';
import {RESTWarehouseParameter} from 'insights/parameters/RESTParameterTypes';
import * as TaskRunner from 'util/TaskRunner';
import withPromisePool from 'util/withPromisePool';

import {ExportQueryOutputSettings, RunQueryOutput} from './AnalyticsWarehouseTypes';

// Keep in sync with sql_query_info.py:get_parameterized_sql_query_info check
function checkRunQueryParameterNames({parameterizedSQLQuery, parameters}: RunQueryData): void {
  const parameterNamesInSQLQuery = getParameterNamesInSQLQueries([parameterizedSQLQuery]);
  const parameterNamesInConfigs = parameters.map((parameter) => parameter.config.systemName);
  assertAndContinue(
    parameterNamesInSQLQuery.every((name) => parameterNamesInConfigs.includes(name)),
    'Expected parameter names in sqlQuery to be a subset of parameterNamesInConfigs (BNCH-12266)',
    {parameterNamesInConfigs, parameterNamesInSQLQuery}
  );
}

export interface RunQueryData {
  parameterizedSQLQuery: string;
  parameters: Array<RESTWarehouseParameter>;
}

function _runUntrustedSQLQuery(data: RunQueryData): Promise<RunQueryOutput> {
  checkRunQueryParameterNames(data);
  return TaskRunner.postJSONPromise({
    url: '/1/api/insights:run-untrusted-sql-query',
    data,
  });
}

export const runUntrustedSQLQuery = withPromisePool(
  _runUntrustedSQLQuery,
  BenchlingConfig.INSIGHTS_MAX_CONCURRENT_QUERIES_PER_BROWSER_TAB
);

export type ExportQueryData = ExportQueryOutputSettings & RunQueryData;

interface ExportQueryOutput {
  url: string;
  warnings: Array<string>;
}

export function exportUntrustedSQLQueryOutputToCSV(data: ExportQueryData): Promise<ExportQueryOutput> {
  return TaskRunner.postJSONPromise({
    url: '/1/api/insights:export-untrusted-sql-query-output-to-csv',
    data,
  });
}
